//export const getRegisterInputs = (subscriptionOptions = []) => {
export const getRegisterInputs = () => {
    return [
        {
            _key: "first_name",
            _name: "First Name",
            _value: "",
            _type: "text",
            _placeholder: "First Name",
            _helperText: "Please enter first name",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 6
        },
        {
            _key: "last_name",
            _name: "Last Name",
            _value: "",
            _type: "text",
            _placeholder: "Last Name",
            _helperText: "Please enter last name",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 6
        },
        {
            _key: "email",
            _name: "Email",
            _value: "",
            _type: "text",
            _placeholder: "Email",
            _helperText: "Please enter email",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 12
        },
        {
            _key: "password",
            _name: "Password",
            _value: "",
            _type: "password",
            _placeholder: "Password",
            _helperText: "Please enter Password",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 12
        },
        {
            _key: "contact",
            _name: "Contact",
            _value: "",
            _type: "text",
            _placeholder: "Contact",
            _helperText: "Please enter Contact",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 12
        },
        // {
        //     _key: "subscription_plan_id",
        //     _name: "Subscription Plan",
        //     _value: "",
        //     _type: "subscription-drop-down",
        //     _placeholder: "Select Plan",
        //     _helperText: "Please select plan",
        //     _mandatory: true,
        //     _options: {
        //         options: subscriptionOptions,
        //     },
        //     _gridSize: 12,
        // },
    ];
}